<template>
  <div class="locker" @click="dblBtn">
    <div class="item">
      <img class="icon" src="../../../static/images/icon_DEPOSIT.png" alt="">
      <p class="title">智能扫码寄存柜</p>
      <div class="img"><img :src="sendEwm" alt=""></div>
      <p class="name">寄存/取件二维码</p>
      <p class="hint">取件时请再次扫描二维码</p>
    </div>
    <!-- <div class="item">
      <p class="name">取件二维码</p>
      <div class="img"><img :src="takeEwm" alt=""></div>
    </div> -->
    <div class="configBtn" v-show="showBtn == true" @click.stop>
      <el-button type="info" @click="toConfig">修改配置</el-button>
    </div>
    <currtime :isShowInfo="false" @click.stop></currtime>
  </div>
</template>

<script>
import currtime from '../../assets/currTime'
import { lockerApi } from "../../../static/js/api.js"
import * as config from '../../../static/js/config.js';
import { showLoading,hideLoading,localUserInfo } from '../../../static/js/utils/utility.js'
export default {
  name:'locker',
  data() {
    return {
      sendEwm:'',//寄存
      takeEwm:'',//取件
      infoData:{
        company_ic:'',//公司ic
        company_id:'',//公司id
        tc_id:'',//主id
      },

      showBtn:false,
      num:0,//点击次数
    }
  },
  components:{
    currtime,
  },
  created(){
    this.getQrCode()
  },
  methods:{
    //获取二维码
    async getQrCode(){
      let that = this;
      const dataObj = {
        'device_no_id': config.deviceId,
      }
      const res = await lockerApi.getQrCode(dataObj)
      if (res.meta.code === 200) {
        that.infoData = res.data
        that.previewImg(res.data,'jc')
        that.previewImg(res.data,'jp')
      } else {
        that.$message.error(res.meta.message)
      }
    },
    //查看二维码
    async previewImg(data,type){
      let that = this;
      showLoading()
      const dataObj = {
        data:{
          "page": "pages/login/login",
          "scene": data.company_ic+type+data.tc_id
        },
        mode: "getUnlimited",
        type: type,
        company_id: data.company_id
      }
      const res = await lockerApi.previewImg(dataObj)
      if (res.meta.code === 200) {
        hideLoading()
        if(type == 'jc'){
          that.sendEwm = res.data.image_url
        }else{
          that.takeEwm = res.data.image_url
        }
        
      } else {
        hideLoading()
        that.$message.error(res.meta.message)
      }
    },
    //跳转到配置页
    toConfig(){
      this.$router.push({
        path:'/CConfigSetting',
        query:{
          'project':true,
        }
      })
    },
    //连续点击屏幕5次
    dblBtn(){
      var that = this;
      this.num++
      if(this.num==1){
        that.timer1=new Date().getTime()/1000
      }
      if(this.num==5){
        this.timer4= new Date().getTime()/1000
        if(that.timer4-that.timer1<=2){
          that.num=0
          that.showBtn=true
          setTimeout(function(){
            that.showBtn = false
          },5000);
        }else {
          this.num=0
        }
      }
    },
  }
}
</script>

<style lang="less">
.locker{
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .item{
    font-size: 0.5rem;
    color: #fff;
    text-align: center;
    margin: 0 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    .icon {
      width: 1.1rem;
    }
    .title {
      font-size: 0.64rem;
      line-height: 0.84rem;
      margin: 0.2rem 0 1.05rem;
    }
    .img{
      width: 4rem;
      height: 4rem;
      img{ 
        width: 100%;
        border-radius: 0.1rem;
      }
    }
    .name{
      font-size: 0.36rem;
      line-height: 0.56rem;
      font-weight: bold;
      margin-top: 0.8rem;
    }
    .hint {
      font-size: 0.36rem;
      line-height: 0.56rem;
    }
  }
  .configBtn{
    position: absolute;
    right: 0.94rem;
    top: 0.47rem;
    z-index: 99;
    .el-button{
      height: 0.94rem;
      // width: 2.54rem;
      padding: 0 0.6rem;
      font-size: 0.4rem;
      color: #fff;
      font-weight: bold;
      border: none;
      border-radius: 0.12rem;
      line-height:0.94rem;
      background: linear-gradient(#4aaafe, #0769be);
    }
  }
  .currTime{
    position: absolute;
    right: 0.2rem;
    top: 0.2rem;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/locker/locker.vue